class KStadiumNeedLoginError extends Error {
  constructor(message?: string) {
    super(message || `KStadium Login Needed`);
  }
}

export default KStadiumNeedLoginError;
